import React from 'react'
import Photo from './Photo';
import { Link } from 'react-router-dom';
import classNames from "classnames";
import $ from "jquery";
import data from "../photos";

class Slider extends React.Component {

	static timeout = null;
	static currentPhoto = 0;

	_elems = [];

	constructor(props) {
		super(props);

		if(!data.dossiers[props.match.params.book])
			throw new Error('Groupe de photo ' + props.match.params.book + ' inconnu');

		this.state = {
			history: props.history,
			prev: false,
			next: true,
			images: [],
		};

		this.key = props.match.params.book;
		this.nom = data.dossiers[props.match.params.book].nom;

		console.log('fetch' + data.dossiers[props.match.params.book].url);

		//Récupération des photos sur le serveur
		let that = this;
		fetch(data.dossiers[props.match.params.book].url)
			.then(function(response) {
				console.log('test2');
				return response.json()
			}).then(function(json) {
			console.log('test3');
				that.setState({images: json.images});
				console.log('test');
				console.log(that.state.images);
		}).catch(function(ex) {
			console.log('Erreur de chargement du groupe de photo ' + props.match.params.book);
			console.log(ex);
		});
	}

	shouldComponentUpdate(nextState) {
		return nextState !== this.state;
	}

	setCurrent = (id) =>
	{
		console.log(this._elems);
		for (let key = 0; key < this._elems.length; key++) {
			this._elems[key].setState({
				current: false,
			});
		}
		this._elems[id].setState({
			current: true,
		});

		Slider.currentPhoto = id;

		return null;
	};

	addPhoto = (photo) =>
	{
		this._elems.push(photo);
	};

	prev = () =>
	{
		if(!this.first())
			this.goTo(Slider.currentPhoto - 1);
	};

	next = () =>
	{
		if(!this.last())
			this.goTo(Slider.currentPhoto + 1);
	};

	first = () =>
	{
		return Slider.currentPhoto <= 0;
	};

	last = () =>
	{
		return Slider.currentPhoto + 1 >= this._elems.length;
	};

	goTo = (id) =>
	{
		let hash = 'photo'+id;

		this.setCurrent(id);

		const gallerie = document.getElementById('gallerie');
		const el = document.getElementById(hash);
		const elOffset = el.offsetLeft;
		const windowWidth = $(gallerie).width();
		const elWidth = el.getBoundingClientRect().width;

		$(gallerie).scrollLeft(elOffset - windowWidth / 2 + elWidth / 2);

		this.setState({
			'prev': this.first(),
			'next': this.last(),
		});
	};

	onKeyDown = (e) =>
	{
		if(e.keyCode === 37)
			this.prev();
		else if(e.keyCode === 39)
			this.next();
		else if(e.keyCode === 27)
			this.props.history.push("/");
	};

	handleScroll = () =>
	{
		if(Slider.timeout)
			clearTimeout(Slider.timeout);
		Slider.timeout = setTimeout(Slider.checkVisiblePhotos, 50);
	};

	checkVisiblePhotos = () =>
	{
		for (let key = 0; key < this._elems.length; key++) {
			if(this._elems[key].checkVisible())
				this._elems[key].setState({'current': true});
			else
				this._elems[key].setState({'current': false});
		}
	};

	componentDidMount() {
		window.addEventListener('keydown', this.onKeyDown);
		//setTimeout(() => { this.goTo(0) }, 300)
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown);
	}

	getClassNamesPrev = () =>
	{
		return classNames({
			'disable': this.state.prev,
			'hi-icon': true,
			'prev': true,
		});
	};

	getClassNamesNext = () =>
	{
		return classNames({
			'disable': this.state.next,
			'hi-icon': true,
			'next': true,
		});
	};

	render() {

		let that = this;

		console.log(this.state);

		return (
			<div id="slider" onScroll={this.handleScroll}>
				<div id="gallerie" className="gallerie">
					<div className="wrap">
						{this.state.images.map(function(img, i){
							return <Photo data={img} id={i} key_album={that.key} prev={that.prev} next={that.next} goTo={that.goTo} addPhoto={that.addPhoto} />;
						})}
					</div>
				</div>
				<h1>
					{this.nom}
				</h1>

				<div id="header-droit">
					<a href={data.dossiers[that.key].zip}>
						<span className="hi-icon"><i className="icon-download"/></span>
					</a>
					<Link to='/'>
						<span className="hi-icon"><i className="icon-cancel"/></span>
					</Link>
				</div>

				<span onClick={this.prev} className={this.getClassNamesPrev()}><i className="icon-left-open"/></span>
				<span onClick={this.next} className={this.getClassNamesNext()}><i className="icon-right-open"/></span>

			</div>
		);
	}
}

export default Slider;


// WEBPACK FOOTER //
// ./src/components/Slider.js